import { API, APIMethod, CompetitionAPI, DesignerAPI, LMSAPI, ProjectAPI, TeamAPI } from '@brg/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Guard } from '@brg/toolbox';
import urlApi from './urlApi';

//const PROJECTS_COUNT_FOR_OFFSET = 20;
const PROJECTS_COUNT_START_OFFSET = 0;
//const PROJECTS_COUNT_LECTURE_OFFSET = 19;

const deduplicate = (array: any[]) => {
  return Array.from(new Set(array))
}

export const merge = (obj1: any = {}, obj2: any = {}) => {

  const commonFields = Object.keys(obj1).reduce((res: any, key) => {
    if (Array.isArray(res[key]) && !!obj2[key]) {
      return {
        ...res,
        [key]: deduplicate([...res[key], ...obj2[key]]),
      }
    }
    return res;
  }, obj1)

  const extraFields = Object.keys(obj2).reduce((res: any, key) => {
    if (!obj1[key] || !Array.isArray(obj1[key])) {
      return {
        ...res,
        [key]: obj2[key],
      }
    }
    return res;
  }, {})

  const projectStatus = obj2?.projectStatus?.length ? obj2.projectStatus : obj1.projectStatus;
  const bookStatus = obj2?.bookStatus?.length ? obj2.bookStatus : obj1.bookStatus;

  return {
    ...commonFields,
    ...extraFields,
    ...(projectStatus ? { projectStatus } : {}),
    ...(bookStatus ? { bookStatus } : {}),
    tags: [],
    requiredTags: [],
    exceptedTags: [],
  }
}

const fetchFeed = async (props: any, options: any = {}) => {
  const urls = new URLSearchParams();
  Object.keys(props).forEach((key) => {
    if (props[key] instanceof Array) {
      for (const val of props[key]) {
        urls.append(key, val);
      }
    } else {
      urls.append(key, props[key]);
    }
  });
  return await API.fetch(
    Guard.void(options.url, ProjectAPI.url) + '/api/project/GetSubscriptionProjects' + '?' + urls.toString(),
    options,
  );
}

const methods = {
  projects: ProjectAPI.GetList,
  competition: CompetitionAPI.GetList,
  books: ProjectAPI.GetList,
  organizations: TeamAPI.GetList,
  modules: LMSAPI.GetModulesList,
  main: ProjectAPI.GetMainPage,
  jury: CompetitionAPI.GetList,
  feed: fetchFeed,
  designer: DesignerAPI.GetList
}

//todo remove duplicate code

export const fetchFolderData = createAsyncThunk(
  'folders/fetchFolderData',
  async (args: any) => {
    const { filter } = args;

    const mainMethod: APIMethod<any, any> = methods.projects;

    const hasProjects = filter?.projectIds?.length > 0;

    if (!hasProjects) {
        return null;
    }
    
    const json = await API.Json(
        mainMethod({
            ...filter,
            limit: filter?.limit,
            offset: PROJECTS_COUNT_START_OFFSET,
            isLite: false
            })
    )

    return {
      ...json,
      prevFilter: filter
    };
  }
);

export const fetchFolders = createAsyncThunk(
  'folders/fetchFolders',
  async (args: any) => {
    const { designerId } = args;

    const data: any = await urlApi().fetchFolders(designerId);

    if (!Array.isArray(data)) {
      return { data: [] }
    }

    return {
      data,
    }

  }
);
import { API, APIMethod, CompetitionAPI, DesignerAPI, LMSAPI, ProjectAPI, TeamAPI } from '@brg/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Guard } from '@brg/toolbox';
import urlApi from './urlApi';

//const PROJECTS_COUNT_FOR_OFFSET = 20;
const PROJECTS_COUNT_START_OFFSET = 0;
//const PROJECTS_COUNT_LECTURE_OFFSET = 19;

const deduplicate = (array: any[]) => {
  return Array.from(new Set(array))
}

export const merge = (obj1: any = {}, obj2: any = {}) => {

  const commonFields = Object.keys(obj1).reduce((res: any, key) => {
    if (Array.isArray(res[key]) && !!obj2[key]) {
      return {
        ...res,
        [key]: deduplicate([...res[key], ...obj2[key]]),
      }
    }
    return res;
  }, obj1)

  const extraFields = Object.keys(obj2).reduce((res: any, key) => {
    if (!obj1[key] || !Array.isArray(obj1[key])) {
      return {
        ...res,
        [key]: obj2[key],
      }
    }
    return res;
  }, {})

  const projectStatus = obj2?.projectStatus?.length ? obj2.projectStatus : obj1.projectStatus;
  const bookStatus = obj2?.bookStatus?.length ? obj2.bookStatus : obj1.bookStatus;

  return {
    ...commonFields,
    ...extraFields,
    ...(projectStatus ? { projectStatus } : {}),
    ...(bookStatus ? { bookStatus } : {}),
    tags: [],
    requiredTags: [],
    exceptedTags: [],
  }
}

const fetchFeed = async (props: any, options: any = {}) => {
  const urls = new URLSearchParams();
  Object.keys(props).forEach((key) => {
    if (props[key] instanceof Array) {
      for (const val of props[key]) {
        urls.append(key, val);
      }
    } else {
      urls.append(key, props[key]);
    }
  });
  return await API.fetch(
    Guard.void(options.url, ProjectAPI.url) + '/api/project/GetSubscriptionProjects' + '?' + urls.toString(),
    options,
  );
}

const methods = {
  projects: ProjectAPI.GetList,
  competition: CompetitionAPI.GetList,
  books: ProjectAPI.GetList,
  organizations: TeamAPI.GetList,
  modules: LMSAPI.GetModulesList,
  main: ProjectAPI.GetMainPage,
  jury: CompetitionAPI.GetList,
  feed: fetchFeed,
  designer: DesignerAPI.GetList
}

//todo remove duplicate code

export const fetchFolderData = createAsyncThunk(
  'folders/fetchFolderData',
  async (args: any) => {
    const { filter } = args;

    const mainMethod: APIMethod<any, any> = methods.projects;

    const hasProjects = filter?.projectIds?.length > 0;

    if (!hasProjects) {
        return null;
    }
    
    const json = await API.Json(
        mainMethod({
            ...filter,
            limit: filter?.limit,
            offset: PROJECTS_COUNT_START_OFFSET,
            isLite: false
            })
    )

    return {
      ...json,
      prevFilter: filter
    };
  }
);

export const fetchFolders = createAsyncThunk(
  'folders/fetchFolders',
  async (args: any) => {
    const { designerId } = args;

    const data: any = await urlApi().fetchFolders(designerId);

    if (!Array.isArray(data)) {
      return { data: [] }
    }

    return {
      data,
    }

  }
);
